<template>
  <v-list-item
    link
    @click="onClick"
    :ref="'control-' + annotationClass.id"
    :class="activeClass"
  >
    <v-list-item-icon>
      <CircleIcon class="icon" v-if="isCircle" :style="iconStyle"></CircleIcon>
      <LineIcon class="icon" v-if="isLineString" :style="iconStyle"></LineIcon>
      <PolygonIcon
        class="icon"
        v-if="isPolygon"
        :style="iconStyle"
      ></PolygonIcon>
      <SquareIcon class="icon" v-if="isSquare" :style="iconStyle"></SquareIcon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ annotationClass.class_name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import CircleIcon from "@/assets/circle.svg";
import PolygonIcon from "@/assets/polygon.svg";
import SquareIcon from "@/assets/square.svg";
import LineIcon from "@/assets/line.svg";

export default {
  props: {
    annotationClass: Object
  },
  data() {
    return {
      control: null,
      type: "annotationClass",
      active: false
    };
  },
  computed: {
    action() {
      return this.annotationClass.annotation_geometry;
    },
    activeClass() {
      if (!this.active) return {};
      return ["active"];
    },
    isPoint() {
      return this.annotationClass.annotation_geometry === "Point";
    },
    isCircle() {
      return this.annotationClass.annotation_geometry === "Circle";
    },
    isPolygon() {
      return this.annotationClass.annotation_geometry === "Polygon";
    },
    isLineString() {
      return this.annotationClass.annotation_geometry === "LineString";
    },
    isSquare() {
      return this.annotationClass.annotation_geometry === "Square";
    },

    iconStyle() {
      const style = {
        fill: this.annotationClass.fill_color,
        stroke: this.annotationClass.color
      };
      if (this.isSquare) {
        style["stroke-width"] = "100px";
      }
      if (this.isCircle) {
        style["stroke-width"] = "20px";
      }
      if (this.isPolygon) {
        style["stroke-width"] = "20px";
      }
      if (this.isLineString) {
        style["stroke-width"] = "20px";
      }

      if (this.active) {
        style["color"] = "#fff";
      }

      return style;
    }
  },
  methods: {
    onClick() {
      this.$emit("click", {
        annotationClass: this.annotationClass,
        control: this.control
      });
    }
  },
  components: { CircleIcon, PolygonIcon, SquareIcon, LineIcon }
};
</script>

<style lang="scss" scoped>
.active {
  background-color: green;
}
</style>
